import styled from 'styled-components';

import View from 'layouts/View';

export default {
  CriticalRequestsView: styled(View)`
    align-items: center;
  `,
};
